import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-lg bg-primary-950 px-6 py-12 md:px-14 md:py-16">
          <span className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-primary-800/40" />
          <span className="absolute -left-8 -bottom-12 w-40 h-40 rounded-full bg-accent-500/20" />
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl md:text-4xl text-background-50 leading-tight">
                你也有想安利的名场面？
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-100/80 leading-7">
                把节目名称、大致时间点和推荐理由告诉我们，编辑团队会逐条查看。合适的推荐会被优先安排进对应分类的合集里。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-400 transition-colors"
              >
                <i className="ri-send-plane-line" />
                推荐看点
              </Link>
              <Link
                to="/faq"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors"
              >
                查看常见问题
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}